import { render } from "./HomePaints.vue?vue&type=template&id=7622d39a&scoped=true&lang=html"
import script from "./HomePaints.vue?vue&type=script&lang=js"
export * from "./HomePaints.vue?vue&type=script&lang=js"

import "./HomePaints.vue?vue&type=style&index=0&id=7622d39a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7622d39a"]])

export default __exports__